export default __webpack_public_path__ + "static/double-profile-rev-1ce9dbaab039fcc0670a050c02eebb4f.jpg";